import { getLogger } from '../diagnostics/logger';
import {
  CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS,
} from '../actions/actionTypes';
import { Action, ActionMeta } from '../actions/commonActions';
import { Loadable } from '../models';
import { PageParameters } from '../models/account';
import { SimManagementError } from '../models/Errors';
import { QueryResult } from '../models/queryResult';
import { initialAppState } from '../models/state/appState';
import { getDefaultUserCommandTypesState, UserCommandTypes } from '../models/state/userCommandTypesState';
const log = getLogger('simManagement.reducers.userRolesReducer');

/**
 * Reducer which deals with processing user command types.
 * @param state Initial state.
 * @param action An action.
 */
export default function userRolesReducer(
  state: Loadable<UserCommandTypes> = initialAppState.userCommandTypes,
  action: Action<any>,
): Loadable<UserCommandTypes> {
  switch (action.type) {
    // user command types
    case CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER: {
      const newState = getDefaultUserCommandTypesState();
      return newState;
    }
    case LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING: {
      const { payload } = action as Action<PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const newState = Object.assign(getDefaultUserCommandTypesState(), {
        companyId: payload.companyId,
        accountId: payload.accountId,
        isLoading: true,
      });

      return newState;
    }
    case LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS: {
      const { payload, meta } = action as ActionMeta<string[], PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const commandTypeIds: string[] = payload;
      const newState = {
        companyId: meta.companyId,
        accountId: meta.accountId,
        all: commandTypeIds,
        isLoading: false,
        lastLoadedOn: new Date(),
      };

      return newState;
    }
    case LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE: {
      const { payload, meta } = action as ActionMeta<SimManagementError, PageParameters>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const newState = Object.assign(getDefaultUserCommandTypesState(), {
        companyId: meta.companyId,
        accountId: meta.accountId,
        error: payload,
      });

      return newState;
    }
  }

  return state;
}
